import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

import Transition from "./Transition";
import { Icon } from "@iconify/react";
import MemberActions from "./MemberActions";

const DIALOG_DISPLAY = [
  {
    label: "Bearbeiten",
    icon: "uil:edit",
    action: "EDIT",
  },
  {
    label: "Anzeigen",
    icon: "bxs:user-detail",
    action: "SHOW",
  },
  {
    label: "Vertrag",
    icon: "material-symbols:contract",
    action: "CONTRACT",
  },
  {
    label: "Kündigen",
    icon: "icon-park-twotone:termination-file",
    action: "TERMINATE",
  },
  {
    label: "Einfrieren",
    icon: "ion:snow",
    action: "FREEZE",
  },
  {
    label: "Löschen",
    icon: "jam:trash",
    action: "DELETE",
  },
];

const DisplayTitle = ({ action }) => {
  let display = DIALOG_DISPLAY.find((d) => d.action === action);

  return (
    <Stack
      direction={"row"}
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <div>
        <Icon width="40" icon={display.icon} />
      </div>
      <div>
        <Typography sx={{ ml: 2 }} variant="h5">
          Mitglied {display.label.toLowerCase()}
        </Typography>
      </div>
    </Stack>
  );
};

function MemberActionsDialog({ handleClose, dialog }) {
  const { action, member } = dialog.data;

  return (
    <Dialog
      open
      TransitionComponent={Transition}
      keepMounted
      maxWidth={"lg"}
      fullWidth
      // onClose={isLoading ? null : () => handleClose("CANCEL")} // Close when click oustside the dialog
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DisplayTitle action={action} />
          <Button onClick={() => handleClose("CANCEL")} color="inherit">
            <Icon width="40" icon="icon-park-solid:close-one" />
          </Button>
        </div>
      </DialogTitle>
      <Divider />

      <MemberActions
        action={action}
        member={member}
        handleClose={handleClose}
      />
    </Dialog>
  );
}

MemberActionsDialog.propTypes = {
  handleClose: PropTypes.func,
  dialog: PropTypes.object,
};

export default MemberActionsDialog;
